export default "__VITE_ASSET__I6hx7W5SDBZbqzNeMIi0Yw__"